import { useState } from 'react';
import { doGet, reportingOrigin, showToast, TEN_SECONDS, TOAST_ERROR } from 'lib/utils';

const TOAST_ERROR_ATTACHMENT = 'Error fetching image from QBO. Please try again later.';

export type AttachmentMetadata = {
  amount: number;
  description: string;
  title: string;
  date: string;
};

function useAttachmentsModal() {
  const [showAttachmentImage, setShowAttachmentImage] = useState<boolean>(false);
  const [attachmentsUrl, setAttachmentsUrl] = useState<string[]>([]);
  const [attachmentMetadata, setAttachmentMetadata] = useState<AttachmentMetadata | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getAttachmentsUrl = async (
    currentLocationId: string | undefined,
    attachments: string[],
    attachmentMetadata: AttachmentMetadata
  ) => {
    if (!currentLocationId) return null;

    // Show modal immediately with loading state
    setIsLoading(true);
    setShowAttachmentImage(true);
    setAttachmentsUrl([]);
    setAttachmentMetadata(attachmentMetadata);

    try {
      const response = await doGet(
        `${reportingOrigin()}/attachments?locationId=${currentLocationId}&ids=${attachments.join(',')}`
      );

      const results: string[] = Object.values(response.data);
      setAttachmentsUrl(results);
    } catch (error) {
      showToast(TOAST_ERROR_ATTACHMENT, TOAST_ERROR, TEN_SECONDS);
      setShowAttachmentImage(false);
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseAttachmentImage = () => {
    setShowAttachmentImage(false);
    setAttachmentsUrl([]);
    setIsLoading(false);
  };

  return {
    showAttachmentImage,
    attachmentsUrl,
    attachmentMetadata,
    isLoading,
    getAttachmentsUrl,
    handleCloseAttachmentImage,
  };
}

export default useAttachmentsModal;
